export default __webpack_public_path__ + "static/media/owoeye.62ded36f.png";